const IS_A_FLOAT = /^-?\d+(\.\d*)?$/
const SPLIT_UP_PARAMS = /[?&]+([^=&]+)=([^&]*)/g

export const getUrlVars = (href = window.location.href) => {
  if (typeof window !== 'undefined' && !href) {
    return {}
  }
  const vars: any = {}
  const trimmedHref = href.split('#')[0]

  trimmedHref.replace(SPLIT_UP_PARAMS, (m, key, value) => {
    let val: any = unescape(value)
    if (IS_A_FLOAT.test(val)) {
      val = parseFloat(val)
    }
    vars[key] = val
    return val
  })

  return vars
}

export const isCaviarDomain = (hostname = window.location.hostname) => {
  return hostname === 'www.trycaviar.com'
}
